import { render } from "./OrganisationListItem.vue?vue&type=template&id=1fdb2cb8&scoped=true"
import script from "./OrganisationListItem.vue?vue&type=script&lang=js"
export * from "./OrganisationListItem.vue?vue&type=script&lang=js"

import "./OrganisationListItem.vue?vue&type=style&index=0&id=1fdb2cb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdb2cb8"]])

export default __exports__